module.exports = __webpack_public_path__ + "img/count.1de0688f.svg";